import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501c4858"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "call"
}
const _hoisted_2 = { class: "settings-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vector" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Checking")
const _hoisted_6 = { class: "call-state" }
const _hoisted_7 = {
  key: 6,
  class: "controls"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vector-horizontal" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://uidesk.id",
    target: "_blank"
  }, "Help"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://uidesk.id",
    target: "_blank"
  }, "Uidesk.id")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MicPermission = _resolveComponent("MicPermission")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Timer = _resolveComponent("Timer")!
  const _component_Settings = _resolveComponent("Settings")!
  const _component_CheckingMic = _resolveComponent("CheckingMic")!
  const _component_Connection = _resolveComponent("Connection")!
  const _component_RedialCall = _resolveComponent("RedialCall")!
  const _component_DtmfKeyboard = _resolveComponent("DtmfKeyboard")!
  const _component_Microphone = _resolveComponent("Microphone")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Decline = _resolveComponent("Decline")!
  const _component_ConnectionRate = _resolveComponent("ConnectionRate")!

  return (!_ctx.isMicAccessGranted)
    ? (_openBlock(), _createBlock(_component_MicPermission, {
        key: 0,
        accessDenied: _ctx.accessDenied
      }, null, 8, ["accessDenied"]))
    : (_ctx.isMicAccessGranted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Button, {
              size: "s",
              mode: "primary",
              width: "fill-container",
              icon: "ic20-settings",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSettings=true))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              size: "s",
              mode: "primary",
              width: "fill-container",
              icon: "ic20-mic",
              onClick: _ctx.startTestMic
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.callState===_ctx.CallState.CONNECTED)
              ? (_openBlock(), _createBlock(_component_Timer, {
                  key: 0,
                  callState: _ctx.callState
                }, null, 8, ["callState"]))
              : _createCommentVNode("", true),
            (_ctx.showSettings)
              ? (_openBlock(), _createBlock(_component_Settings, {
                  key: 1,
                  "onUpdate:closeSettings": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettings=false)),
                  call: _ctx.call
                }, null, 8, ["call"]))
              : _createCommentVNode("", true),
            (_ctx.checkingOpened)
              ? (_openBlock(), _createBlock(_component_CheckingMic, {
                  key: 2,
                  "onUpdate:checking": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkingOpened=false)),
                  sdk: _ctx.sdk
                }, null, 8, ["sdk"]))
              : _createCommentVNode("", true),
            (_ctx.callState===_ctx.CallState.CONNECTING)
              ? (_openBlock(), _createBlock(_component_Connection, {
                  key: 3,
                  "onUpdate:cancelBtn": _ctx.disconnect
                }, null, 8, ["onUpdate:cancelBtn"]))
              : _createCommentVNode("", true),
            (_ctx.callState===_ctx.CallState.DISCONNECTED)
              ? (_openBlock(), _createBlock(_component_RedialCall, {
                  key: 4,
                  "onUpdate:callBtn": _ctx.createCall
                }, null, 8, ["onUpdate:callBtn"]))
              : _createCommentVNode("", true),
            (_ctx.callState===_ctx.CallState.CONNECTED)
              ? (_openBlock(), _createBlock(_component_DtmfKeyboard, {
                  key: 5,
                  "onUpdate:digit": _ctx.sendDigit
                }, null, 8, ["onUpdate:digit"]))
              : _createCommentVNode("", true),
            (_ctx.callState===_ctx.CallState.CONNECTED)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_Hint, { text: _ctx.micHint }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Microphone, {
                        call: _ctx.call,
                        "onUpdate:isMuted": _ctx.changeMicHint
                      }, null, 8, ["call", "onUpdate:isMuted"])
                    ]),
                    _: 1
                  }, 8, ["text"]),
                  _createVNode(_component_Hint, { text: "End the call" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Decline, { onClick: _ctx.disconnect }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Hint, { text: "Indicator connection" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ConnectionRate, { call: _ctx.call }, null, 8, ["call"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _hoisted_9
        ]))
      : _createCommentVNode("", true)
}